
var options = $.extend({}, bq.config.growl);

bq.growl.init(options);